import React, { useState, useEffect } from "react";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ComboDetailsUpdateComponent from "./component";
import { useParams } from "react-router-dom";
import debounce from "lodash.debounce";
import dayjs from "dayjs";

const ComboDetailsUpdateContainer = (props) => {
  const { comboId } = useParams();
  const navigate = useNavigate();

  const [applyOnKiosk, setApplyOnKiosk] = useState(false);
  const [applyOnConsumerApp, setApplyOnConsumerApp] = useState(false);
  const [loading, setLoading] = useState(true);
  const [mvId, setMvId] = useState("");
  const [selectedMvId, setSelectedMvId] = useState("");
  const [mvIdList, setMvIdList] = useState([]);
  const [comboDetailsData, setComboDetailsData] = useState({});
  const [selectedMvItems, setSelectedMvItems] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [mvConfig, setMvConfig] = useState([]);
  const [imagePath, setImagePath] = useState(null);
  const [isImageUploaded, setIsImageUploaded] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [errors, setErrors] = useState({});
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [filteredMvList, setFilteredMvList] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    sellingPrice: "",
    mrp: "",
    filePreview: null,
    applyOnKiosk: false,
    applyOnConsumerApp: false,
    mvId: "",
    selectedMvId: "",
    selectedMvItems: [],
    startDate: null,
    endDate: null,
    mvConfig: [],
    imagePath: null,
  });

  // Fetch MV list on component mount
  useEffect(() => {
    fetchMvList();
  }, []);

  const fetchMvList = () => {
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/mvs/all?limit=100&isActive=1&offset=0`,
      "GET",
      undefined,
      (response) => {
        const list = response?.list || [];
        setMvIdList(list);
        setFilteredMvList(list);
      },
      (err) => {
        console.error("Error fetching MV list:", err);
        toastr.error("Error", "Failed to fetch MV list");
      }
    );
  };

  const filteredMvIdList = Array.isArray(mvIdList)
    ? mvIdList.filter(
        (item) =>
          item.id &&
          item.id.toString().toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const handleCloseSuccessModal = () => {
    setSuccessModalOpen(false);
    navigate(-1);
  };

  const handleSelectMvId = (item) => {
    setSelectedMvItems((prevItems) => {
      if (prevItems.some((selectedItem) => selectedItem.id === item.id)) {
        return prevItems;
      }
      return [
        ...prevItems,
        { id: item.id, quantity: 1, mrp: item.mrp, price: item.mrp, isFetched: false },
      ];
    });
    setModalOpen(false);
  };

  const handleRemoveMvId = (id) => {
    setSelectedMvItems((prevItems) =>
      prevItems.filter((item) => item.id !== id)
    );
  };

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          imagePreview: reader.result,
          selectedImage: file,
        }));
      };
      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({
        ...prev,
        imagePreview: null,
        selectedImage: null,
      }));
    }
  };

  const handleImageUpload = () => {
    if (!formData.selectedImage) {
      toastr.error("Error", "Please select an image");
      return;
    }

    const uploadData = new FormData();
    uploadData.append("image_file", formData.selectedImage);
    uploadData.append("image_type", "combo");
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/screensaver/upload`,
      "POST",
      uploadData,
      (response) => {
        toastr.success("Success", "Image uploaded successfully");
        setFormData((prev) => ({
          ...prev,
          filePreview: null,
          imagePath: response.screenSaverUrl,
          isImageUploaded: true,
        }));
      },
      (err) => {
        toastr.error("Failed", "Unable to upload image");
      }
    );
  };

  const handleRemoveFile = () => {
    setFormData((prev) => ({
      ...prev,
      filePreview: null,
      imagePreview: null,
      imagePath: null,
      image_url: null,
    }));
    setSelectedImage(null);
  };

  const fetchedImageUrl =
    formData && formData?.image_url
      ? `https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${formData.image_url}`
      : null;

  const incrementQuantity = (id) => {
    setSelectedMvItems((prevSelected) =>
      prevSelected.map((item) =>
        item.id === id ? { ...item, quantity: (item.quantity || 0) + 1 } : item
      )
    );
  };

  const decrementQuantity = (id) => {
    setSelectedMvItems((prevSelected) => {
      const updatedItems = prevSelected.map((item) =>
        item.id === id
          ? { ...item, quantity: Math.max((item.quantity || 1) - 1, 0) }
          : item
      );
      return updatedItems.filter((item) => item.quantity > 0);
    });
  };

  const handleQuantityChange = (id, newQuantity) => {
    setSelectedMvItems((prevSelected) =>
      prevSelected.map((item) =>
        item.id === id ? { ...item, quantity: newQuantity } : item
      )
    );
  };

  useEffect(() => {
    handleComboDetailsApi();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
  };

  const handleDateChange = (name, date) => {
    const formattedDate = date ? date.toISOString() : null;
    setFormData((prev) => ({ ...prev, [name]: formattedDate }));
  };

  const handleComboDetailsApi = () => {
    setFormData((prev) => ({ ...prev, loading: true }));
    props.getDataFromAPI(
      `/partner/api/v2/combo/${comboId}`,
      "GET",
      undefined,
      (response) => {
        const mvConfigItems = (response.mv_config || []).map((item) => ({
          id: item.mv_id,
          quantity: item.quantity,
          mrp: item.price,
          price: item.price,
        }));

        setFormData((prev) => ({
          ...prev,
          loading: false,
          comboDetailsData: response,
          name: response.name || "",
          description: response.description || "",
          sellingPrice: response.actual_price || "",
          mrp: response.total_price || "",
          startDate: response.activates_at || null,
          endDate: response.expires_at || null,
          applyOnKiosk: response.kiosk_app_enabled || false,
          applyOnConsumerApp: response.consumer_app_enabled || false,
          image_url: response.image_url || null,
        }));

        setSelectedMvItems(mvConfigItems);
      },
      (err) => {
        setFormData((prev) => ({ ...prev, loading: false }));
        toastr.error(`${err.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      },
      true
    );
  };

  const handleUpdateComboApi = () => {
    const mvConfigPayload = selectedMvItems
      .filter((item) => item.quantity > 0)
      .map((item) => ({
        mv_id: item.id,
        quantity: item.quantity,
        price: parseInt(item.price || item.mrp) || 0,
      }));
    
    const payload = {
      name: formData.name,
      description: formData.description,
      total_price: parseInt(formData.mrp) || 0,
      actual_price: parseInt(formData.sellingPrice) || 0,
      activates_at: formData.startDate,
      expires_at: formData.endDate,
      consumer_app_enabled: formData.applyOnConsumerApp,
      kiosk_app_enabled: formData.applyOnKiosk,
      image_url: formData.imagePath,
      mv_config: mvConfigPayload,
      combo_cohorts: [],
    };

    props.getDataFromAPI(
      `/partner/api/v2/combo/${comboId}/update`,
      "PATCH",
      payload,
      (response) => {
        toastr.success("Success", "Combo updated successfully");
        navigate("/home/combolist");
      },
      (err) => {
        console.log("API Error:", err);
        toastr.error("Error", err?.status?.message || "Failed to update combo");
      }
    );
  };

  const handleSearchMvId = debounce((query = "") => {
    if (query.trim() === "") {
      setFilteredMvList(mvIdList);
      return;
    }

    props.getDataFromAPI(
      `/dashboard/api/v2/admin/mvs/all?limit=50&offset=0&isActive=1&search=${query}`,
      "GET",
      undefined,
      (response) => {
        setFilteredMvList(response?.list || []);
      },
      (err) => {
        console.error("API Error:", err);
      }
    );
  }, 300);

  const handleSearchQueryChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    handleSearchMvId(value);
  };

  return (
    <ComboDetailsUpdateComponent
      handleUpdateComboApi={handleUpdateComboApi}
      comboDetailsData={comboDetailsData}
      startDate={startDate}
      endDate={endDate}
      imagePreview={imagePreview}
      applyOnKiosk={applyOnKiosk}
      applyOnConsumerApp={applyOnConsumerApp}
      mvConfig={mvConfig}
      setStartDate={setStartDate}
      setEndDate={setEndDate}
      setApplyOnKiosk={setApplyOnKiosk}
      setApplyOnConsumerApp={setApplyOnConsumerApp}
      handleQuantityChange={handleQuantityChange}
      handleFileChange={handleFileChange}
      incrementQuantity={incrementQuantity}
      handleRemoveFile={handleRemoveFile}
      setMvConfig={setMvConfig}
      mvIdList={mvIdList}
      setMvId={setMvId}
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      selectedMvId={selectedMvId}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      filteredMvIdList={filteredMvIdList}
      handleOpenModal={handleOpenModal}
      handleSelectMvId={handleSelectMvId}
      handleCloseModal={handleCloseModal}
      decrementQuantity={decrementQuantity}
      setSelectedMvItems={setSelectedMvItems}
      selectedMvItems={selectedMvItems}
      errors={errors}
      successModalOpen={successModalOpen}
      handleCloseSuccessModal={handleCloseSuccessModal}
      handleImageUpload={handleImageUpload}
      selectedImage={selectedImage}
      isImageUploaded={isImageUploaded}
      fetchedImageUrl={fetchedImageUrl}
      formData={formData}
      handleInputChange={handleInputChange}
      handleCheckboxChange={handleCheckboxChange}
      handleDateChange={handleDateChange}
      setFormData={setFormData}
      handleRemoveMvId={handleRemoveMvId}
      handleSearchMvId={handleSearchMvId}
      filteredMvList={filteredMvList}
      handleSearchQueryChange={handleSearchQueryChange}
      mvId={mvId}
    />
  );
};

function mapStateToProps(props) {
  return {
    props,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(ComboDetailsUpdateContainer);